import { Fragment, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { ReduxService } from 'dashboard-services/services';

import ColumnSettings from '../ColumnSettings';
import Row from '../Row';

const emptyArray = []
const SymbolContent = ({ ...props }) => {
  const scrollRef = useRef(),
        selectedSymbols = useSelector(state => state.seriesState.creatorState.selectedSymbols) || emptyArray,
        filteredItems = useMemo(() => selectedSymbols.map((item, orgIndex) => ReduxService.updateObject(item, { orgIndex })).filter(s => s.pattern === "false"), [selectedSymbols])

  return (
  <Fragment>
    <div className="ng-office-app__authed__content__basket__body__data__basket__headers">
      <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
        Group
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
        Symbol
      </div>
      <ColumnSettings/>
    </div>
    <div 
        className="ng-office-app__authed__content__basket__body__data__basket__items"
        ref={scrollRef}
    >
      {filteredItems.map((filteredItem, filteredItemIndex) => (
        <Row
            {...filteredItem}
            {...props}
            index={filteredItemIndex}
            key={filteredItemIndex}
            scrollRef={scrollRef}
        />
      ))}

    </div>
  </Fragment>
  )
}

export default SymbolContent;